/*
 * Copyright (c) 2018 OCLC, Inc. All Rights Reserved.
 *
 * OCLC proprietary information: the enclosed materials contain proprietary information of OCLC Online Computer
 * Library Center, Inc. and shall not be disclosed in whole or in any part to any third party or used by any person
 * for any purpose, without written consent of OCLC, Inc.  Duplication of any portion of these materials shall include
 * this notice.
 */
import { connect } from 'react-redux';

import {DomainApplicationMenu} from './DomainApplicationMenu';

import applications from '../applications';
import institutions from '../institutions';

import {bindActionCreators} from 'redux';
import {navigateToApplication, getActiveApplication} from './state';

/**
 * Map state from the Redux store to properties on the component.
 *
 * @param state state from the Redux store.
 *
 * @returns {{applications, institution}}
 */
const mapStateToProps = state => {
  return {
    applications: applications.selectors.getVisibleApplications(state),
    active: getActiveApplication(state),
    contextInstitution: institutions.selectors.getContextInstitutionId(state)
  };
};

/**
 * Map dispatch actions to properties on the component.
 *
 * @param dispatch
 * @returns {{loadApplications: *|Function|Object|fetchApplications|ActionCreator<any>|ActionCreatorsMapObject}}
 */
const mapDispatchToProps = dispatch => ({
  onSelectMenuItem: bindActionCreators(navigateToApplication, dispatch)
});

export const DomainApplicationMenuContainer = connect(mapStateToProps, mapDispatchToProps)(DomainApplicationMenu);



// WEBPACK FOOTER //
// ./src/DomainApplicationView/DomainApplicationMenuContainer.js